module.exports = __webpack_public_path__ + "media/images/f-logo-rgb-blue-72@2x-edf4091407f38b9c58418373037849f0.png";